import { FooterLinkContext as o } from "./FooterLinkContext.es.js";
import { useContext as t } from "react";
var i = () => t(o).link;
export {
  i as useFooterLink
};
